import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classnames from 'classnames';

import getIcon from '../common/Icon';

import type { IndexBlockPlanPeacePanelProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/IndexBlockPlanPeacePanel';

import STYLES from './IndexBlockPlanPeacePanel.module.scss';

export default function IndexBlockPlanPeacePanel(
  props: IndexBlockPlanPeacePanelProps,
) {
  if (!props || !props.dataList || !props.dataList.length) {
    return null;
  }

  return (
    <div
      className={STYLES.IndexBlockPlanPeacePanel}
      data-testid="indexBlockPlanPeacePanel"
    >
      <div className={STYLES.IndexBlockPlanPeacePanel__container}>
        <div className={STYLES.IndexBlockPlanPeacePanel__topText}>
          <BpkText tagName="h2" textStyle={TEXT_STYLES.heading3}>
            {props.title}
          </BpkText>
          <BpkText tagName="p">{props.desc}</BpkText>
        </div>
        <div className={STYLES.IndexBlockPlanPeacePanel__itemList}>
          {props.dataList.map((item) => {
            const Icon = getIcon(item.icon);
            return (
              <article
                key={item.title}
                className={classnames(STYLES.IndexBlockPlanPeacePanel__item)}
              >
                <div
                  className={STYLES.IndexBlockPlanPeacePanel__imgBox}
                  data-testid="plan-peace-icon"
                >
                  <Icon />
                </div>
                <div className={STYLES.IndexBlockPlanPeacePanel__itemHead}>
                  <BpkText tagName="p" textStyle={TEXT_STYLES.label1}>
                    {item.title}
                  </BpkText>
                </div>
                <div className={STYLES.IndexBlockPlanPeacePanel__itemBody}>
                  <BpkText tagName="p">{item.content}</BpkText>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}
